module.exports = __webpack_public_path__ + "img/vote-10.e3c26519.png";